var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic/settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M53.7790913,28.7261114 C53.8263697,28.3433914 53.8617609,27.9546572 53.8617609,27.56 C53.8617609,27.1653428 53.8263697,26.7766086 53.7790913,26.3938886 L56.2788085,24.4145883 C56.503403,24.2351656 56.568422,23.9122228 56.4206435,23.6490572 L54.0567276,19.5049377 C53.9090392,19.2478046 53.6017751,19.14016 53.3357558,19.2478046 L50.3927031,20.4497823 C49.7840286,19.97736 49.1161886,19.5766977 48.3951267,19.2717246 L47.9519713,16.1023109 C47.8988395,15.8212577 47.6564143,15.6 47.3609473,15.6 L42.6331157,15.6 C42.3375587,15.6 42.0953136,15.8212577 42.0480353,16.1023109 L41.6048798,19.2717246 C40.883818,19.5766977 40.215978,19.9713823 39.6073124,20.4497823 L36.6642417,19.2478046 C36.3983034,19.1461377 36.0909944,19.2478046 35.9432519,19.5049377 L33.5793361,23.6490572 C33.4315936,23.9062086 33.4965945,24.2290603 33.721171,24.4145883 L36.2151067,26.3938886 C36.1678284,26.7766086 36.1323652,27.1653428 36.1323652,27.56 C36.1323652,27.9546572 36.1678284,28.3433914 36.2151067,28.7261114 L33.721171,30.7054117 C33.4965945,30.8848344 33.4315936,31.2077772 33.5793361,31.4709428 L35.9432519,35.6150714 C36.0909944,35.8722228 36.3983034,35.97984 36.6642417,35.8722228 L39.6073124,34.6702086 C40.215978,35.1425944 40.883818,35.543357 41.6048798,35.8482572 L42.0480353,39.0176344 C42.0953136,39.2987514 42.3375587,39.52 42.6331157,39.52 L47.3609473,39.52 C47.6564143,39.52 47.8988395,39.2987514 47.9461178,39.0176344 L48.3892732,35.8482572 C49.1103351,35.543357 49.778085,35.1486997 50.3867596,34.6702086 L53.3299023,35.8722228 C53.5957415,35.9738258 53.9030956,35.8722228 54.0507841,35.6150714 L56.41479,31.4709428 C56.5624784,31.2137914 56.4975495,30.8909397 56.272955,30.7054117 L53.7790913,28.7261114 Z M44.9971216,31.7460456 C42.7100217,31.7460456 40.8602238,29.8742714 40.8602238,27.56 C40.8602238,25.2457286 42.7100217,23.3739544 44.9971216,23.3739544 C47.2841313,23.3739544 49.1339292,25.2457286 49.1339292,27.56 C49.1339292,29.8742714 47.2841313,31.7460456 44.9971216,31.7460456 L44.9971216,31.7460456 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Version-12",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A03",
    transform: "translate(-408.000000, -232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "screen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "settings-copy",
    transform: "translate(375.000000, 215.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tabs",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "general"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "ic/settings",
    fill: "#B4C3D0",
    xlinkHref: "#path-1"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon_settings.2644801c2f59352e52d7c70ff82ce5a0.svg";
export { ForwardRef as ReactComponent };